import "./gastosCard.css";
import { formatearFechaHora } from "../../../../utils/fechas.js";
import { formatearPrecio } from "../../../../utils/precios.js";

export default function GastosCard({ gasto, abierta, onToggle }) {
  return (
    <div className="factura-card" onClick={onToggle}>
      {/* ================= RESUMEN ================= */}
      <div className="factura-row">
        <div className="factura-info">
          <span>
            <strong> id: {gasto.id_gasto}</strong> -
            {formatearFechaHora(gasto.fecha_creacion)}
          </span>
          <span>Destino: {gasto.id_categoria}</span>
          <span>Precio: $ {formatearPrecio(gasto.item_valor)}</span>
          <span className={`estado estado-${gasto.estado}`}>
            {gasto.estado}
          </span>
        </div>
      </div>

      {/* ================= DETALLE ================= */}
      {abierta && (
        <div className="factura-detalle">
          <div className="factura-info">
            <div>Metodo: {gasto.metodo_pago}</div>
            <div>Cantidad: {gasto.item_cantidad}</div>
          </div>
          <small>Observaciones:</small> {gasto.detalle ?? "-"}
          <div></div>
        </div>
      )}
    </div>
  );
}
